import { ClockIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { formatTimestamp } from '../../../../utils/discipline/formatters';
import { obligationAdministrationTimeline } from '../../../../utils/discipline/obligationAudit';

const AuditMeta = ({ actor, timestamp }) => (
  <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-base-content/60">
    <span className="inline-flex items-center gap-1">
      <UserCircleIcon className="h-3.5 w-3.5" />
      {actor}
    </span>
    {timestamp && (
      <span className="inline-flex items-center gap-1">
        <ClockIcon className="h-3.5 w-3.5" />
        {formatTimestamp(timestamp)}
      </span>
    )}
  </div>
);

const ObligationAuditDetails = ({ event, actorNamesById = {} }) => {
  const timeline = obligationAdministrationTimeline(event, actorNamesById);
  if (timeline.length === 0) return null;

  return (
    <section className="rounded-lg border border-base-300 bg-base-200/30 p-3" aria-label="Administration details">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-base-content/60">
        Administration details
      </h4>

      <div className="mt-2 divide-y divide-base-300">
        {timeline.map(row => (
          <div key={row.id} className="py-2 first:pt-0 last:pb-0 text-sm">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <span className="font-medium">{row.label}</span>
              {row.transition && <span className="text-xs text-base-content/60">{row.transition}</span>}
            </div>
            <AuditMeta actor={row.actor} timestamp={row.timestamp} />
            {(row.reason || row.details) && (
              <p className="mt-1 text-xs text-base-content/70">{row.reason || row.details}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ObligationAuditDetails;
